type Guard = () => Promise<boolean>;
const guards = new Set<Guard>();

/** Editors can finish a pending write before the router unmounts them. */
export function registerNavigationGuard(guard: Guard): () => void {
  guards.add(guard);
  return () => {
    guards.delete(guard);
  };
}

export function pendingNavigation(): Promise<boolean> | null {
  if (!guards.size) return null;
  const current = [...guards];
  return (async () => {
    for (const guard of current) {
      try {
        if (!(await guard())) return false;
      } catch {
        return false;
      }
    }
    return true;
  })();
}
